export default __webpack_public_path__ + "static/thumb-20-a0654cba1b68b64a0989252dc5fef58d.jpg";